import { render, staticRenderFns } from "./informationConfirmation.vue?vue&type=template&id=7b3f0bb2&scoped=true"
import script from "./informationConfirmation.vue?vue&type=script&lang=js"
export * from "./informationConfirmation.vue?vue&type=script&lang=js"
import style0 from "./informationConfirmation.vue?vue&type=style&index=0&id=7b3f0bb2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3f0bb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b3f0bb2')) {
      api.createRecord('7b3f0bb2', component.options)
    } else {
      api.reload('7b3f0bb2', component.options)
    }
    module.hot.accept("./informationConfirmation.vue?vue&type=template&id=7b3f0bb2&scoped=true", function () {
      api.rerender('7b3f0bb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/frontPageManage/configureManage/configure/components/informationConfirmation.vue"
export default component.exports